/* OpenClaw Preis-Anker */
(function() {
  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function() {
    var priceEl = document.querySelector('.price-item--regular') || document.querySelector('.price');
    if (priceEl) {
      var current = priceEl.textContent.replace(/[^0-9,]/g, '').replace(',', '.');
      var uvp = (parseFloat(current) * 1.3).toFixed(2).replace('.', ',');
      var anker = document.createElement('div');
      anker.className = 'oc-preis-anker';
      anker.innerHTML = 'UVP: <s>' + uvp + ' €</s> <span class="oc-save">Du sparst 30%!</span>';
      priceEl.insertAdjacentElement('afterend', anker);
    }
  });
})();